import supabase from 'modules/core/supabase/supabase';
import { mapChampionshipSettings } from 'modules/championship/domain/data-mappers/championship-settings.data-mapper';
import { toast } from 'react-toastify';
import getGameInfo from '../repositories/match-by-id';
import { updateFoulPeriods } from './update-foul-periods';
import { updateMembersStats } from './update-members-stats';

export async function getMappedGameInfo(matchId: number) {
  const gameInfo = await getGameInfo(matchId);
  if (!gameInfo) return undefined;

  const settings = mapChampionshipSettings(gameInfo.championship?.settings);
  supabase.matchChronology.init(settings);

  try {
    if (gameInfo.match?.id) {
      const events = await supabase.matchChronology.getRow(gameInfo?.match?.id ?? 0);
      if (events) {
        await updateMembersStats(gameInfo, events);
        await updateFoulPeriods(gameInfo, events);
      }
    }

    return gameInfo;
  } catch (error) {
    if (error instanceof Error) {
      if (error.message.includes('gamePeriodsNumber or periodTime is 0 or null, it must be set in the settings')) {
        toast.error(
          'Добавьте "Количество периодов в матче" и "Длительность матча". \nВ настройках турнира перейдите на вкладку "Условия", а затем в "Регламент".',
          {
            autoClose: false,
            bodyStyle: {
              whiteSpace: 'pre-line',
            },
          },
        );
      }
    }

    throw error;
  }
}
